import type {
  CasOrCategory,
  JurisdictionThresholdRuleID,
  ProductID,
  StateThresholdDefinition,
  StateThresholdOutcome,
  StateThresholdReviewInput,
  StateThresholdReviewRecord,
  ThresholdProgram,
} from '../../tri-shared/types/db.ts';

/** An in-progress assessment; the outcome is unset until the user chooses one. */
export type StateThresholdReviewDraft = Omit<StateThresholdReviewInput, 'outcome'> & {
  outcome: StateThresholdOutcome | null;
};
export interface StateThresholdEntryOption {
  key: string;
  label: string;
  basis: 'compound' | 'mixture';
  included: boolean;
  detail: string;
  disabledReason: string | null;
}
export interface StateThresholdReviewItem {
  ruleID: JurisdictionThresholdRuleID;
  stateCode: string;
  reportingYear: number;
  definition: StateThresholdDefinition;
  fingerprint: string;
  review: StateThresholdReviewRecord | null;
  status: 'needs_review' | 'stale' | 'reviewed';
  issues: string[];
}
export const THRESHOLD_PROGRAM_LABELS: Record<ThresholdProgram, string> = {
  tier_ii: 'State Tier II requirements',
  ca_hmbp: 'California HMBP',
  nj_crtk: 'New Jersey CRTK',
  or_cr2k: 'Oregon CR2K',
};
export const thresholdEntryKey = (
  entry: { basis: 'mixture'; productID: ProductID } | { basis: 'compound'; casOrCategory: CasOrCategory },
) => (entry.basis === 'mixture' ? `product:${entry.productID}` : `chemical:${entry.casOrCategory}`);
